$(function () {

    // find IndexMethod polyfill for IE
    if (!Array.prototype.findIndex) {
        Object.defineProperty(Array.prototype, 'findIndex', {
            value: function(predicate) {
                // 1. Let O be ? ToObject(this value).
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }

                let o = Object(this);

                // 2. Let len be ? ToLength(? Get(O, "length")).
                let len = o.length >>> 0;

                // 3. If IsCallable(predicate) is false, throw a TypeError exception.
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }

                // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
                let thisArg = arguments[1];

                // 5. Let k be 0.
                let k = 0;

                // 6. Repeat, while k < len
                while (k < len) {
                    // a. Let Pk be ! ToString(k).
                    // b. Let kValue be ? Get(O, Pk).
                    // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                    // d. If testResult is true, return k.
                    let kValue = o[k];
                    if (predicate.call(thisArg, kValue, k, o)) {
                        return k;
                    }
                    // e. Increase k by 1.
                    k++;
                }

                // 7. Return -1.
                return -1;
            },
            configurable: true,
            writable: true
        });
    }

    function showPrice() {
        setTimeout(function(){
            $('.ui-datepicker .ui-datepicker-calendar tbody td').each(function () {
                if($(this).hasClass('has-price') && $(this).find("span.price"). length === 0) {
                    let results = $(this).attr("class").match(/price-\d+/i);
                    let price = results && results.length > 0 ? results[0].split('-')[1] : '0';
                    if($.isNumeric(price) && price !== '0') $(this).append('<span class="price">$'+price+'</span>');
                }
            });
        },  0);
        console.log('update prices');
    }

    const months = ["Jan","Feb","March","April","May","Jun","Jul","Aug","Sept","Oct","Nov","Dec"];

    //HTML to CHANGE WHEN SELECTED
    function changeDateHTML(target, day, month){
        target.html("<span>"+ day + "</span>" + month);
    }

    const CheckIn__selector = $("#checkIn--date"),
        CheckOut__selector = $("#checkOut--date");

    $.post(site_url + "ajax/functions.php", {
        operation: 'getDayPricesFromTravelTripper',
        hotel_id: "HGBSA",
        portal_id: "hotelgibbs",
    }, function(data) {

        const dataDates = data.dates;
        const dataPrices =  data.prices;

        $.datepicker._defaults.dateFormat = "mm/dd/yy";
        $.datepicker._defaults.dateFormat_alt = "yy-mm-dd";
        const fullmonth_array = $.datepicker._defaults.monthNames;


        $('#date-selection').datepicker({
            inline: true,
            numberOfMonths: 2,
            minDate: 0,
            changeMonth: true,
            monthNamesShort: fullmonth_array,
            beforeShowDay: function(date) {
                let startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $.trim($("#CheckIn--alt").val())),
                    endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $.trim($("#CheckOut--alt").val())),
                    dmy =  date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + ("0" + date.getDate()).slice(-2) ;

                let index = dataDates.findIndex(x => x === dmy),
                    style = startDate && ((date.getTime() === startDate.getTime())|| (endDate && date >= startDate && date <= endDate) ) ? "dp-highlight " : "";

                if ($.inArray(dmy, dataDates) !== -1 && dataPrices[index] != 0 ) {
                    return [true,' has-price ' + style + 'price-' + dataPrices[index]];
                } else {
                    return [true, startDate && ((date.getTime() === startDate.getTime()) || (endDate && date >= startDate && date <= endDate) ) ? "dp-highlight" : "pointer-none ui-datepicker-unselectable ui-state-disabled"];
                }
            },
            onChangeMonthYear: function(date) {
                showPrice();
            },
            onSelect: function (date) {
                let date1 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $.trim( $("#CheckIn--alt").val()) ),
                    date2 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $.trim( $("#CheckOut--alt").val()) ),
                    selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date),

                //DATE SELECTED
                thisDate = $(this).datepicker('getDate'),
                    day  = thisDate.getDate(),
                    month = months[thisDate.getMonth()];

                    //var date_alt = new Date(Date.parse(thisDate)).format("MM/dd/yyyy");

                    var parts = date.split('/');
                    var date_alt = parts[2] + '-' + parts[0] + '-' + parts[1];
                if (!date1 || date2) {
                    $("#CheckIn--alt").val(date);
                    $("#checkIn--alt2").val(date_alt);
                    $("#CheckOut--alt").val("");
                    $("#checkOut--alt2").val("");
                    $("#checkOut--alt2").val("");

                    // changeDateHTML(CheckIn__selector, day, month);
                    // console.log('checkin');
                } else if( selectedDate < date1 ) {
                    $("#CheckIn--alt").val(date);
                    $("#checkIn--alt2").val(date_alt);
                    $("#CheckOut--alt").val("");
                    $("#checkOut--alt2").val("");

                    // changeDateHTML(CheckIn__selector, day, month);
                    // console.log('change dates');
                } else {
                    $("#CheckOut--alt").val(date);
                    $("#checkOut--alt2").val(date_alt);

                    // changeDateHTML(CheckOut__selector, day, month);
                    // console.log('checkout');
                }
                showPrice();
            }
        });

        showPrice();


        //Check in and check out datepicker for booking engine
        $( "#CheckIn" ).datepicker({
            changeMonth: true,
            numberOfMonths: 2,
            minDate: 0,
            dateFormat: "mm/dd/yy",
            altField: "#checkIn-alt",
            altFormat: "yy-mm-dd",
            monthNamesShort: fullmonth_array,
            beforeShowDay: function(date) {
                let dmy =  date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + ("0" + date.getDate()).slice(-2) ;

                if ($.inArray(dmy, dataDates) !== -1) {
                    let index = dataDates.findIndex(x => x === dmy);
                    return [true,'has-price price-' + dataPrices[index]];
                } else {
                    return [true];
                }

            },
            beforeShow: function(date) {
                showPrice();
            },
            onChangeMonthYear: function(date) {
                showPrice();
            },
            onSelect: function( selectedDate ) {
                let getDate = $(this).datepicker('getDate'),
                    newDate = new Date(getDate.getTime()),

                    checkIn = $(this).datepicker('getDate'),
                    checkInDay  = checkIn.getDate(),
                    checkInmonth = months[checkIn.getMonth()];

                //CHANGE HTML CHECK IN DATE
                changeDateHTML($("#checkIn--date-alt"), checkInDay, checkInmonth);


                //ADD 3 days to selected date
                newDate.setDate(newDate.getDate() + 3);

                //SELECT DATE ON CHECK OUT AND CHANGE HTML
                $( "#CheckOut" ).datepicker( "setDate", newDate );
                $( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );

                let checkOutDay  = newDate.getDate(),
                    checkOutmonth = months[newDate.getMonth()];

                // changeDateHTML($("#checkOut--date-alt"), checkOutDay, checkOutmonth);

            }
        });
        $( "#CheckOut" ).datepicker({
            dateFormat: "mm/dd/yy",
            // dateFormat: "d M",
            altField: "#checkOut-alt",
            altFormat: "yy-mm-dd",
            changeMonth: true,
            numberOfMonths: 2,
            monthNamesShort: fullmonth_array,
            beforeShowDay: function(date) {
                let dmy =  date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + ("0" + date.getDate()).slice(-2) ;

                if ($.inArray(dmy, dataDates) !== -1) {
                    let index = dataDates.findIndex(x => x === dmy);
                    return [true,'has-price price-' + dataPrices[index]];
                } else {
                    return [true];
                }

            },
            beforeShow: function(date) {
                showPrice();
            },
            onChangeMonthYear: function(date) {
                showPrice();
            },
            onSelect: function( selectedDate ) {
                //$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );

                let checkOut = $(this).datepicker('getDate'),
                    checkOutDay  = checkOut.getDate(),
                    checkOutmonth = months[checkOut.getMonth()];

                // changeDateHTML($("#checkOut--date-alt"), checkOutDay, checkOutmonth);
            }
        });

    }, "json");

});